{
  "list": {
    "attributes": {
      "friendlyName": "Nom",
      "type": "Type",
      "serialNumber": "Numéro de série",
      "firmwareVersion": "Version logicielle",
      "hardwareVersion": "Version matérielle",
      "state": "État",
      "createdAt": "Date de création",
      "connectivity": {
        "name": "Connectivité",
        "connected": {
          "lessThan": "L'équipement s'est connecté il y a moins de {duration}.",
          "greaterThan": "L'équipement s'est connecté il y a plus de {duration}."
        },
        "duration": {
          "seconds": "{count} seconde | {count} seconde | {count} secondes",
          "minutes": "{count} minute | {count} minute | {count} minutes",
          "hours": "{count} heure | {count} heure | {count} heures"
        }
      },
      "metastatus": {
        "name": "Metastatus",
        "status": {
          "success": "Toutes les dernières opérations de cet équipement se sont bien déroulées.",
          "mixed": "Au moins une des dernières opérations de cet équipement est en erreur.",
          "error": "Toutes les dernières opérations de cet équipement sont en erreur."
        }
      },
      "sector": "Secteur",
      "actionInProgress": "Actions en cours",
      "certificateExpirationRange": "Certificat"
    }
  },
  "stateValue": {
    "PREPROVISIONED": "Pré-provisionné",
    "REGISTERED": "Enregistré"
  },
  "import": {
    "title": "Importer",
    "text": "Importer",
    "header": {
      "text": "Importer des équipements pré-provisionnés"
    },
    "clickToUpload": "Cliquez pour sélectionner",
    "orDragAndDrop": "ou glissez et déposez un fichier .ZIP",
    "action": {
      "report": "Analyser",
      "execution": "Importer"
    },
    "inProgress": {
      "report": "Analyse en cours...",
      "execution": "Importation en cours..."
    },
    "results": {
      "report": {
        "total": "Aucun équipement détecté | 1 équipement détecté | {count} équipements détectés",
        "succeed": {
          "exist": "Équipements validés à mettre à jour :",
          "new": "Équipements validés à créer :"
        },
        "failed": "Équipements en échec :"
      },
      "execution": {
        "total": "Aucun équipement traité | 1 équipement traité | {count} équipements traités",
        "succeed": {
          "exist": "Équipements mis à jour :",
          "new": "Équipements créés :"
        },
        "failed": "Équipements en échec :"
      }
    },
    "validation": {
      "fileMandatory": "Le fichier doit être un .ZIP",
      "fileEmpty": "Le fichier .ZIP ne doit pas être vide"
    }
  },
  "form": {
    "description": {
      "title": "Description",
      "idCard": {
        "title": "Carte d'identité",
        "attributes": {
          "name": "Nom",
          "type": "Type",
          "model": "Gamme",
          "serialNumber": "Numéro de série",
          "hardwareVersion": "Version matérielle",
          "manufacturer": "Fabricant",
          "sector": "Secteur"
        }
      },
      "state": {
        "title": "État",
        "attributes": {
          "state": "État",
          "firstConnection": "Première connexion",
          "lastConnection": "Dernière connexion",
          "batteryStatus": "Statut de la batterie",
          "lastChange": "Dernier changement",
          "configurationApplicationDate": "Date d'application de la configuration",
          "lastRebootDate": "Date du dernier redémarrage",
          "firstCommissioningDate": "Date de la première mise en service",
          "certificateExpirationDate": "Date d'expiration du certificat",
          "firmwareVersion": "Version firmware",
          "latestFirmwareUpdate": "Dernière mise à jour du firmware",
          "lastCertificateUpdate": "Dernière mise à jour du certificat",
          "lastSynchronisation": "Dernière synchronisation de l’équipement :",
          "lastDisconnectionDate": "Date de dernière déconnexion"
        }
      },
      "connectivity": {
        "title": "Connectivité",
        "communication": "Communication",
        "simCard": "Carte SIM",
        "attributes": {
          "antenna": "Antenne",
          "mobileNetwork": "Réseau mobile",
          "gsmFrequencyBand": "Bande de fréquence GSM",
          "communicationProtocol": "Protocole de communication",
          "accessPointName": "Nom du point d'accès (APN)",
          "userName": "Nom utilisateur"
        },
        "status": "Statut de la connectivité"
      },
      "geolocation": {
        "title": "Description du site",
        "attributes": {
          "address": "Adresse",
          "latlong": "Lat : {latitude} - Lon : {longitude}",
          "status": "Géolocalisation"
        }
      },
      "characteristics": {
        "title": "Caractéristiques"
      }
    },
    "configuration": {
      "title": "Configuration",
      "information": {
        "configurationType": {
          "label": "Type de configuration",
          "SELF_SUPPORTING": "Auto-portante",
          "GLOBAL_AND_SPECIFIC": "Globale + spécifique"
        },
        "selfSupportingVersion": "Version autoportante",
        "globalVersion": "Version globale",
        "specificVersion": "Version spécifique",
        "configurationOrigin": "Origine de la configuration",
        "lastUpdate": "Dernière mise à jour"
      },
      "operations": {
        "title": "Opérations"
      },
      "upload": {
        "userInformation": {
          "title": "Import d’une configuration",
          "description": "Cette configuration ne sera disponible que pour cet équipement."
        },
        "error": {
          "invalidFileType": "Le fichier doit être au format JSON ou JWT.",
          "fileSize": "La taille du fichier de configuration doit être inférieure à 750 Mo.",
          "emptyFile": "Le fichier de configuration ne doit pas être vide.",
          "fileAlreadyExist": "Ce fichier de configuration existe déjà pour cet équipement."
        },
        "title": "Import d'une configuration",
        "confirm": {
          "title": "Annulation de l’import de la configuration",
          "message": "Êtes-vous sûr de vouloir annuler l’opération d’import de configuration ? \nToutes les données seront perdues."
        },
        "form": {
          "title": "Informations de la configuration",
          "versionName": "Nom de la version",
          "version": "Version",
          "type": "Type"
        },
        "buttonTooltip": "Importer une configuration",
        "success": "L’import de la configuration s’est déroulé succès"
      },
      "update": {
        "title": "Mise à jour de la configuration",
        "warning": "L'équipement a déjà une opération du même type planifiée ou en cours.",
        "scheduling": {
          "title": "Planification",
          "label": "Planifiez la mise à jour",
          "placeholder": "Sélectionnez une date de mise à jour"
        },
        "configurationSelection": {
          "title": "Configuration",
          "radio": {
            "specific": "Spécifique",
            "globalAndSpecific": "Globale et spécifique"
          },
          "label": "Sélectionnez une configuration dans la liste ci-dessous",
          "placeholder": "Sélectionnez une configuration",
          "specific": "Configuration spécifique",
          "global": "Configuration globale"
        },
        "instantSending": {
          "label": "Envoi instantané",
          "tooltip": "Transmission de l’opération à l'équipement dès que possible."
        },
        "cancel": {
          "confirm": {
            "title": "Annulation de la mise à jour de la configuration",
            "message": "Êtes-vous sûr de vouloir annuler l’opération de mise à jour de configuration ? \nToutes les données seront perdues."
          }
        }
      },
      "browse": {
        "selfSupporting": "Parcourir les configurations auto-portantes",
        "specific": "Parcourir les configurations spécifiques"
      },
      "list": {
        "title": {
          "selfSupporting": "Configurations auto-portantes",
          "specific": "Configurations spécifiques"
        },
        "search": {
          "placeholder": "Rechercher par nom de version ou par version"
        },
        "noConfiguration": "Aucune configuration n'a été trouvée",
        "columns": {
          "versionName": "Nom de la version",
          "version": "Version",
          "uploadedDate": "Date d'ajout"
        },
        "periodPicker": {
          "placeholder": "Sélectionnez une période"
        }
      },
      "delete": {
        "selectedConfigurations": "Aucune configuration sélectionnée | {count} configuration sélectionnée | {count} configurations sélectionnées",
        "confirm": {
          "title": "Aucune configuration sélectionnée | Supprimer la configuration | Supprimer les configurations",
          "message": "Aucune configuration sélectionnée | Êtes-vous sûr de vouloir supprimer la configuration sélectionnée ? | Êtes-vous sûr de vouloir supprimer les configurations sélectionnées ?"
        }
      }
    },
    "dataviz": {
      "title": "Visualisation de données",
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois",
      "quarter": "Trimestre",
      "newChart": "Glissez et déposez une donnée ici pour créer un nouveau graphique.",
      "noData": "Aucune données"
    },
    "firmware": {
      "title": "Firmware",
      "state": {
        "attributes": {
          "firmwareVersion": "Version",
          "latestFirmwareUpdate": "Dernière mise à jour"
        }
      },
      "information": {
        "attributes": {
          "latestFirmwareUpdate": "Dernière mise à jour",
          "firmwareUpdateSource": "Origine",
          "firmwareUpdateSourceOption": {
            "mobileApp": "Application mobile",
            "factory": "Usine"
          }
        }
      },
      "updateFirmware": "Mise à jour du firmware"
    },
    "logs": {
      "title": "Logs",
      "lastOperationReportUpdateDate": {
        "label": "Date de transfert du dernier rapport de fonctionnement"
      },
      "noLogsFound": "Aucun log trouvé"
    },
    "additionalMetadata": {
      "title": "Métadonnées additionnelles",
      "options": {
        "title": "Options",
        "processControl": "Automatisme",
        "pumpingStation": "Poste de Relèvement",
        "webServer": "Serveur Web",
        "webMimicDiagram": "Synoptiques Web",
        "ipBackup": "Secours IP ADSL / GSM",
        "iecSlave": "IEC60870-5-104 Slave",
        "externalControlLiftStation": "Commande externe de PR",
        "pumpingOptimization": "Optimisation du pompage",
        "dataPoints": "Nombre d'informations : {value}",
        "ioModules": "Nombre de modules I/O : {value}",
        "comModules": "Nombre de modules COM : {value}",
        "calendars": "Nombre de calendriers : {value}",
        "schedules": "Nombre de schedules : {value}",
        "objects": "Nombre d’objets : {value}",
        "allowedLocalPost": "Postes locaux autorisés : {value}",
        "licenceExpirationDate": "Date d’expiration de la licence : {value}",
        "licenceId": "N° de licence : {value}"
      },
      "communicationModules": {
        "title": "Modules de communication"
      },
      "modules": {
        "location": "Emplacement",
        "module": "Module"
      },
      "ioModules": {
        "title": "Modules I/O"
      },
      "networkInterfaceCardExtensions": {
        "title": "Extension(s) de la carte d'interface réseau"
      },
      "ioCardExtensions": {
        "title": "Extension(s) de la carte IO"
      },
      "modemCardExtensions": {
        "title": "Extension(s) de la carte modem"
      },
      "comments": {
        "title": "Commentaires"
      }
    },
    "certificate": {
      "title": "Certificat",
      "information": {
        "title": "Certificat",
        "attributes": {
          "certificateExpirationDate": "Date d’expiration du certificat",
          "lastCertificateUpdate": "Dernière date de mise à jour du certificat",
          "origin": "Origine du certificat",
          "origins": {
            "mobileApplication": "Application mobile",
            "lxConnect": "LX CONNECT"
          }
        }
      }
    }
  },
  "empty": "Aucun équipement n'a été trouvé",
  "lifeCycleState": {
    "preprovisioned": "Pré-provisionné",
    "registered": "Enregistré",
    "activated": "Activé",
    "disabled": "Désactivé",
    "locked": "Verrouillé"
  },
  "filters": {
    "searchByNameOrSerialNumber": "Rechercher par nom ou numéro de série",
    "compatibilityQuickFilters": {
      "allDevices": "Tous les équipements",
      "compatibleDevices": "Équipements compatibles",
      "incompatibleDevices": "Équipements incompatibles"
    },
    "deviceType": "Type",
    "selectionQuickFilters": {
      "allDevices": "Tous les équipements",
      "selectedDevices": "Équipements sélectionnés",
      "unselectedDevices": "Équipements non sélectionnés"
    },
    "lifecycleState": "État",
    "connectivity": {
      "label": "Connectivité",
      "type": "Type de connexion de l'équipement",
      "status": "Statut",
      "SHORT_LIVED": "Polling",
      "GOOD": "Moins de 24 heures",
      "WARN": "Plus de 24 heures",
      "ERROR": "Plus de 72 heures",
      "empty": "Aucun statut disponible",
      "PERSISTENT": "Persistant",
      "ONLINE": "Connecté",
      "OFFLINE": "Déconnecté"
    },
    "ranges": {
      "label": "Gamme"
    }
  },
  "fleet": {
    "cancelSelection": "Annuler la sélection",
    "selectedDevices": "Aucun dispositif sélectionné | {count} équipement sélectionné | {count} équipements sélectionnés",
    "addToFleet": "Ajouter à une flotte",
    "removeFromFleet": "Retirer de la flotte"
  },
  "deviceFound": "Aucun équipement n'a été trouvé | {count} équipement trouvé | {count} équipements trouvés",
  "action": {
    "enable": "Activer l'équipement",
    "disable": "Désactiver l'équipement",
    "confirm": {
      "title": "Désactiver l'équipement ?",
      "description": "Êtes-vous sûr de vouloir désactiver cet équipement ? Cette action empêchera toute communication avec la plateforme et toutes les opérations seront annulées.",
      "disable": "Désactiver"
    },
    "button": {
      "enable": "Activer",
      "disable": "Désactiver"
    },
    "delete": {
      "tooltip": "Supprimer l'équipement",
      "confirm": {
        "title": "Suppression d'équipement",
        "message": "La suppression d’un équipement entraîne l’effacement définitif de toutes ses données, comprenant ses opérations et la télémétrie."
      }
    }
  },
  "cartography": {
    "title": "Cartographie",
    "deviceMapTile": {
      "button": {
        "seeDevice": "Voir l’équipement"
      }
    },
    "devicesMap": {
      "noDevices": "Aucun équipement à afficher"
    }
  },
  "globalConfiguration": {
    "automaticRenewalDelay": {
      "information": {
        "title": "Délai de renouvellement de certificat automatique",
        "body": "Définit combien de temps avant son expiration le certificat de l'équipement sera renouvelé automatiquement."
      },
      "label": "Délai de renouvellement de certificat automatique",
      "values": {
        "nDay": "1 jour | {n} jours",
        "nMonth": "1 mois | {n} mois",
        "nYear": "1 an | {n} ans"
      },
      "custom": {
        "label": "Personnalisé",
        "unit": "jour | jours"
      },
      "error": {
        "required": "Le délai de renouvellement est obligatoire",
        "minMax": "Le délai de renouvellement doit être compris entre {min} et {max}"
      }
    },
    "pollingFrequency": {
      "information": {
        "title": "Fréquence d’interrogation",
        "body": "Définit l’intervalle de temps entre deux communications de l'équipement vers la plateforme."
      },
      "label": "Fréquence d’interrogation",
      "values": {
        "nMinute": "1 minute | {n} minutes",
        "nHour": "1 heure | {n} heures"
      },
      "custom": {
        "label": "Personnalisé",
        "unit": "minute | minutes"
      },
      "error": {
        "required": "La fréquence d'interrogation est obligatoire",
        "minMax": "La fréquence d'interrogation doit être comprise entre {min} et {max}"
      }
    }
  }
}
